import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import Hero from './components/Hero';
import Services from './components/Services';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import { siteInfo, homeFaqs } from '@/mocks/home';

export default function Home() {
  const organizationSchema = {
    name: '亚洲在线',
    url: 'https://skzswl.cn',
    description: '亚洲最全在线服务平台，汇聚亚洲各地优质资源与内容，提供便捷、安全、高效的在线体验。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-8888',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '上海',
      streetAddress: '浦东新区陆家嘴金融贸易区世纪大道100号',
    },
    foundingDate: '2020',
    numberOfEmployees: { '@type': 'QuantitativeValue', value: '200+' },
  };

  const websiteSchema = {
    name: '亚洲在线',
    url: 'https://skzswl.cn',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://skzswl.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    name: '亚洲在线 - 首页',
    url: 'https://skzswl.cn',
    description: siteInfo.description,
  };

  const faqSchema = {
    mainEntity: homeFaqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="WebPage" data={webpageSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <FeaturedArticles />
          <FAQ />
          <CTA />
        </main>
        <Footer />
      </div>
    </>
  );
}